/**
 * This file was auto-generated by Fern from our API Definition.
 */

export type ObservationType =
  | "SPAN"
  | "GENERATION"
  | "EVENT"
  | "AGENT"
  | "TOOL"
  | "CHAIN"
  | "RETRIEVER"
  | "EVALUATOR"
  | "EMBEDDING"
  | "GUARDRAIL";
export const ObservationType = {
  Span: "SPAN",
  Generation: "GENERATION",
  Event: "EVENT",
  Agent: "AGENT",
  Tool: "TOOL",
  Chain: "CHAIN",
  Retriever: "RETRIEVER",
  Evaluator: "EVALUATOR",
  Embedding: "EMBEDDING",
  Guardrail: "GUARDRAIL",
} as const;
